import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Button } from '../../components/Button';
import { blogAxios } from '../../utils/blogAxios';
import { useGlobalContext } from '../../context/global/context';
import Notification from 'rc-notification';
import { useNavigate } from 'react-router';
import ReactLoading from 'react-loading';

export const PublishConfig = ({ publishVisible, setPublishVisible, oldArticle, ...articleAttr }) => {
	const [tagList, setTagList] = useState([]);
	const [allCategories, setAllCategories] = useState([]);
	const [publishing, setPublishing] = useState(false);
	const navigate = useNavigate();

	const [category, setCategory] = useState();
	const [tags, setTags] = useState([]);

	useEffect(() => {
		if (oldArticle) {
			setCategory(oldArticle.category ? oldArticle.category.id : '');
			setTags(oldArticle.tags.map(item => item.id));
		}
	}, [oldArticle]);

	const { state } = useGlobalContext();

	useEffect(() => {
		blogAxios.get('/tags').then(({ data }) => {
			setTagList(data);
		});

		blogAxios.get('/categories').then(({ data }) => {
			setAllCategories(data);
			if (data.length !== 0) setCategory(data[0].id);
		});
	}, []);

	const toggleTag = id => {
		const next = tags.includes(id) ? tags.filter(item => item !== id) : [...tags, id];
		setTags(next);
	};

	const handlePublish = () => {
		if (publishing) {
			return;
		}

		const params = {
			createdAt: new Date(),
			publishedAt: new Date(),
			...oldArticle,
			...articleAttr,
			tags,
			category,
			published: true,
			user: state.userInfo.id,
			updatedAt: new Date()
		};

		const promise = oldArticle?.id
			? blogAxios.put(`/articles/${oldArticle.id}`, params)
			: blogAxios.post('/articles', params);

		setPublishing(true);
		promise
			.then(({ data }) => {
				Notification.newInstance({}, n =>
					n.notice({
						content: <span>发布成功</span>
					})
				);
				window.localStorage.removeItem(oldArticle?.id ? `blog-draft-${oldArticle.id}` : 'blog-draft-public');
				navigate(`/blog/detail/${data.id}`);
			})
			.catch(e =>
				Notification.newInstance({}, n =>
					n.notice({
						content: <span>发布失败，请重试</span>
					})
				)
			)
			.finally(() => setPublishing(false));
	};

	return (
		<div
			style={{
				position: 'fixed',
				maxHeight: 'calc(100vh - 60px)',
				overflow: 'auto',
				bottom: 12,
				right: 48,
				background: '#FFFFFF',
				boxShadow: '0 0 10px 2px rgba(0,0,0,0.10)',
				width: 450,
				boxSizing: 'border-box',
				padding: '24px 28px',
				zIndex: 10000,
				display: publishVisible ? 'block' : 'none'
			}}
		>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}
			>
				<h3
					style={{
						margin: 0
					}}
				>
					发布文章
				</h3>
				<span onClick={() => setPublishVisible(false)}>
					<i
						style={{
							cursor: 'pointer'
						}}
						className="icon authing-icon authing-guanbi"
					></i>
				</span>
			</div>

			<div className="config-item">
				<h4 className="config-item-title">文章分类</h4>
				<div className="tag-container">
					{allCategories.map(item => {
						return (
							<span
								onClick={() => setCategory(item.id)}
								className={classnames([
									'tag-item',
									{
										active: category === item.id
									}
								])}
								key={item.id}
							>
								{item.name}
							</span>
						);
					})}
				</div>
			</div>
			<div className="config-item">
				<h4 className="config-item-title">文章标签</h4>
				<div className="tag-container">
					{tagList.map(item => {
						return (
							<span
								onClick={() => toggleTag(item.id)}
								className={classnames([
									'tag-item',
									{
										active: tags.includes(item.id)
									}
								])}
								key={item.id}
							>
								{item.name}
							</span>
						);
					})}
				</div>
			</div>

			<Button
				style={{
					marginTop: 50
				}}
				onClick={handlePublish}
			>
				{publishing ? <ReactLoading type="spokes" height={20} width={20} /> : '确认发布'}
			</Button>
		</div>
	);
};
